<template>
    <div class="mt-3">
        <apexchart
            type="donut"
            :height="363.75"
            :width="358.75"
            :options="chartOptions"
            :series="chartData"
        />
    </div>
</template>
<script>
import i18n from '@/i18n'
export default {
    name: 'Donut',
    props: {
        title: {
            type: Number,
        },
        startAngle: {
            type: Number,
            default: -90,
        },
        endAngle: {
            type: Number,
            default: 90,
        },
        chartData: {
            type: Array,
            default: () => [],
        },
    },
    watch: {
        title() {
            const options = { ...this.chartOptions }
            options.title.text = this.title
            this.chartOptions = options
        },
    },
    data: function() {
        return {
            chartOptions: {
                xaxis: {
                    categories: [
                        i18n.t('enps.report.detractors'),
                        i18n.t('enps.report.neutral'),
                        i18n.t('enps.report.promoters'),
                    ],
                },
                tooltip: {
                    custom({ series, seriesIndex, w }) {
                        const percent = series[seriesIndex]
                        const label = w.globals.labels[seriesIndex]
                        return `<div class="custom-tooltip">${percent}% ${label}</div>`
                    },
                },
                plotOptions: {
                    pie: {
                        startAngle: this.startAngle,
                        endAngle: this.endAngle,
                    },
                },
                responsive: [
                    {
                        breakpoint: 1100,
                        options: {
                            chart: {
                                height: 254.625,
                                width: 251.125,
                            },
                            title: {
                                text: this.title,
                                align: 'center',
                                offsetY: 77,
                                floating: true,
                                style: {
                                    fontWeight: 'bold',
                                    fontFamily: 'Roboto',
                                    fontSize: '67px',
                                },
                            },
                        },
                    },
                ],
                grid: {
                    padding: {
                        bottom: -80,
                    },
                },
                colors: ['#DE5B5B', '#E7A42F', '#359C61'],
                legend: {
                    show: false,
                },
                dataLabels: {
                    enabled: false,
                },
                title: {
                    text: this.title,
                    align: 'center',
                    offsetY: 110,
                    floating: true,
                    style: {
                        fontWeight: 'bold',
                        fontFamily: 'Roboto',
                        fontSize: '96px',
                    },
                },
            },
        }
    },
}
</script>
<style scoped lang="scss">
/deep/ .custom-tooltip {
    padding: 4px;
    position: relative;
    background: #555;
    border: 2px solid #000000;
}
</style>
